import Vue from "vue";
import { post, fetch, Del, put } from "../../../../ask/axios";
import menberMenu from '../../../../components/userCenter/public/menberPageMenu.vue'
export default {
  components: { menberMenu },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      }, 
      Bill:{},
      titNames: "Pick-up service",
      titUrls: ",",

      //=====第三部分=======//
      showThree:1,
     
      // 币种
      isHaveUSD:false,isHaveEUR:false,isHaveRMB:false,isHaveHK:false,
      //取件订单详情
      ThBillInfo:{
        THBillNo:'',Cost:null,
        ProvinceName:'',CityName:'',CityAreaName:'',
        LinkManName:'',LinkTel:'',LinkEmail:'',Address:'',
        BillStatus:'',
        planCargoDate:'',Estimated:'',
        LadingName:'',LadingPhone:'',VehicleNo:'',Remark:'',
        ActualWeight:'',ActualVolume:'',ActualPCS:'',
         //收件人信息
         DestContactName:'',DestContactMobile:'',DestContactAddr:'',
      },

       pickupOrderData:[],//提货订单列表
       costInfoData:[],//费用信息

       THOrderService:null,//取件单方式，0：关联国际订单，1：独立取件单。老数据默认初始化为0 ,
       THOrderEnType:null,


    };
  },

  created() {//创建后

  },
  mounted() {//载入dom后周期函数
    this.getThDetailsApi(); //取件订单详情接口
    this.costList(); //费用接口

  },
  watch: {},
  computed: {//计算属性周期函数
    packageNum(){
      let k=0
      if(this.pickupOrderData.length>0){
        this.pickupOrderData.forEach(e=>{
          k+=e.PackagesNum
        })
        return k
      }
    },
    ActualKg(){
      let k=0
      if(this.pickupOrderData.length>0){
        this.pickupOrderData.forEach(e=>{
          k+=e.OrderWeight
        })
        return k
      }
    },
  },
  methods: {
    //=====第三部分=========//
    clkTab(k){
      this.showThree=k 
    }, 

    //取件订单详情接口
    getThDetailsApi(){
      let that=this
      that.api.param={
        THBillNo:that.$route.query.thNo
      }
      // that.api.url=that.$api03+'/api/TradeCustomer/PickupOrders/Detail'
      that.api.url=that.$api04 + '/Pickup/api/PickupOrderQuery/GetTHWayBillOrderDetail'
      fetch(that.api.url,that.api.param).then(function (res) {
        if(res.Results){
          that.THOrderService=res.Results.THOrderService //

          that.THOrderEnType=res.Results.HOrderEnType

          that.ThBillInfo.THBillNo=res.Results.THBillNo
          that.ThBillInfo.Cost=res.Results.Cost  //预估费用
          //头部信息
          that.ThBillInfo.ProvinceName=res.Results.ConnectInfo.ProvinceNameEn
          that.ThBillInfo.CityName=res.Results.ConnectInfo.CityNameEn
          //that.ThBillInfo.CityAreaName=res.Results.ConnectInfo.CityAreaName

          that.ThBillInfo.LinkManName=res.Results.ConnectInfo.LinkManName   //联系人
          that.ThBillInfo.LinkTel=res.Results.ConnectInfo.LinkTel  //联系电话
          that.ThBillInfo.LinkEmail=res.Results.ConnectInfo.LinkEmail  //联系电话
          that.ThBillInfo.address=res.Results.ConnectInfo.ProvinceName+ res.Results.ConnectInfo.CityName +res.Results.ConnectInfo.CityAreaName +res.Results.ConnectInfo.Address  //寄件地址 
          
          that.ThBillInfo.BillStatus=res.Results.BillStatus //提货状态
          // 如果状态是已删除就一开始显示费用信息  并隐藏需求取件的选项  
          if(that.THOrderService==1 || that.ThBillInfo.BillStatus ==7){
            that.showThree=2
          }
           that.ThBillInfo.planCargoDate=res.Results.ConnectInfo.PlanCargoDate  //预计取件时间
           if(res.Results.ConnectInfo.PlanArriveDate){
            that.ThBillInfo.Estimated=res.Results.ConnectInfo.PlanArriveDate  //到仓时间
           }
           

            //提货司机，司机电话，车牌号
            that.ThBillInfo.LadingName=res.Results.ConnectInfo.LadingName  //提货司机，
            that.ThBillInfo.LadingPhone=res.Results.ConnectInfo.LadingPhone  //司机电话
            that.ThBillInfo.VehicleNo=res.Results.ConnectInfo.VehicleNo  //车牌号
            that.ThBillInfo.Remark=res.Results.Remark   //备注

            that.ThBillInfo.ActualWeight=res.Results.ActualWeight //收货实重
            that.ThBillInfo.ActualVolume=res.Results.ActualVolume //收货体积
            that.ThBillInfo.ActualPCS=res.Results.ActualPCS //收货件数
                        
            that.pickupOrderData=res.Results.GoodsInfoList  //需要提货的订单

            //收件人信息
            that.ThBillInfo.DestContactName=res.Results.ConnectInfo.DestContactName
            that.ThBillInfo.DestContactMobile=res.Results.ConnectInfo.DestContactMobile
            that.ThBillInfo.DestContactAddr=res.Results.ConnectInfo.DestProvinceNameEn+res.Results.ConnectInfo.DestCityNameEn+res.Results.ConnectInfo.DestCityAreaNameEn+res.Results.ConnectInfo.DestAddress 

        }

      })
    },
    handleBill(data) {
      // 都要对应位置  1 为 RMB 2 USD 3 HK 4 EUR
      let index =  ['isHaveRMB','isHaveUSD','isHaveHK','isHaveEUR'] //币种索引
      let UnpayIndex = ['UnpayCny','UnpayUSD','UnpayHK','UnpayEUR'] //上方未支付币种统计索引
      let sumIndex = ['SumCNY','SumUSD','SumHK','SumEUR'] //总计币种统计索引
      data.forEach(e => {
        // 用于显示的总金额
        if(e.Currency == 1){
          e.allAmout = e.Amount
        } else {
          e.allAmout = e.ConvertAmount
        }
        //  BillStatus 1 ==>已完成 
        if(e.BillStatus== 1) {
          e.UnpayAmount =  e.CreditAmount - e.PayCreditAmount
        } else {
          e.UnpayAmount = e.allAmout  - e.AccountAmount - e.PayCreditAmount
        }
        //统计加和未支付 状态已完成的也有未支付
        this.Bill[UnpayIndex[e.Currency-1]] += Number(e.UnpayAmount) 
        this.Bill[sumIndex[e.Currency-1]] += Number(e.allAmout) 
        this.Bill[index[e.Currency-1]] = true //是否显示该币种
      });
    },
    //费用信息接口
    costList() {
      this.api.param={
        THBillNo:this.$route.query.thNo
      }
      // this.api.url=this.$api03+"/api/TradeCustomer/PickupBill/GetCusFee";
      this.api.url=this.$api04 + "/Pickup/api/PickupOrderQuery/GetCusFee";
      fetch(this.api.url,this.api.param).then( (res)=> {
        if(res.IsOK){
          this.costInfoData=res.Results  //费用信息
          this.Bill = {
            Show:this.costInfoData,
            isHaveRMB:false,isHaveUSD:false,isHaveHK:false,isHaveEUR:false,
            UnpayCny:0,UnpayUSD:0,UnpayHK:0,UnpayEUR:0,
            SumCNY:0,SumUSD:0,SumHK:0,SumEUR:0,
          }
          this.handleBill(this.costInfoData)
        }
      })
    },
    //点击编辑订单
    clkEditThOrder(){
      ///pickUp/pickUpEdit?thNo=TH02002001216
      this.$router.push({
        path: "/pickUp/pickUpEdit",
        query: {
          thNo:this.ThBillInfo.THBillNo,
        }
      })
    },

     //取件单状态
     judState(val){
      if(val==1) return 'Distributing'
      if(val==2) return 'Waiting'
      if(val==3) return 'Picking up'
      if(val==4) return 'Picked up'
      if(val==5) return 'Delivered'
      if(val==6) return 'Terminated'
      if(val==7) return 'Deleted'
    },
    //货物信息中订单类型转换  1、快递；3、空运；20、fba
    typeConversion(val){
      if(val==1) return'Express'
      if(val==3) return'Air Freight'
      if(val==20) return'FBA'
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/pickup/pickupDetails.js